module.exports = __webpack_public_path__ + "img/block24.0a3fb7f2.png";